import { createContext, useContext } from "react";

export const TopBarSlotContext = createContext<HTMLElement | null>(null);

export function useTopBarSlot(): HTMLElement | null {
  return useContext(TopBarSlotContext);
}
